<template>
  <el-tooltip v-if="shuttleLoadStatus >= statusLoaded" class="item" effect="dark" :content="$t('outbound.loads.print')" placement="top-start">
    <span>
      <i class="el-icon-printer icon-action" @click="print()" />
    </span>
  </el-tooltip>
</template>

<script>
import { mapActions } from 'vuex';
import { Loading } from 'element-ui';
import constants from '@/utils/constants';
import { SHUTTLE_LOAD_PRINT_SHUTTLE_SHEET } from '@/store/actions';

export default {
  name: 'PrintShuttleSheetButton',
  props: {
    shuttleLoadId: {
      type: Number,
      default: null
    },
    shuttleLoadStatus: {
      type: Number,
      default: null
    }
  },
  computed: {
    statusLoaded: () => constants.SHUTTLE_LOADS.STATUS[3].value
  },
  methods: {
    ...mapActions({
      printShuttleSheet: SHUTTLE_LOAD_PRINT_SHUTTLE_SHEET
    }),
    print() {
      const loading = Loading.service(constants.LOADING.PRINT_SHUTTLE_LOAD_CONFIG);
      this.printShuttleSheet(this.shuttleLoadId).finally(() => {
        loading.close();
      });
    },
  }
};
</script>
